import { FamilyMember, Story, ArchiveItem } from '../types';

export const INITIAL_MEMBERS: FamilyMember[] = [
  // GENERATION 1: Settlers & Founders (Arrived 1850s - 1860s)
  {
    id: 'denton-john-f',
    firstName: 'John Frederick',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1805,
    birthPlace: 'Suffolk, England',
    deathYear: 1857,
    deathPlace: 'Christchurch, New Zealand',
    isLiving: false,
    bio: 'John Frederick Denton emigrated from Great Barton, Suffolk, England to Lyttelton aboard the First Four Ship "Sir George Seymour" in December 1850 with his family. He acquired land at Opawa and Eyreton before his death in 1857. He is buried in Plot 33 at Barbadoes Street Cemetery.',
    occupation: 'Farmer & Canterbury Pilgrim',
    generation: 1,
    branchTag: 'Denton Family',
    spouseIds: ['denton-esther'],
    childrenIds: [
      'denton-arthur-john', 
      'denton-thomas-charles', 
      'denton-john-frederick-jr'
    ],
    sourceReferences: [
      { 
        title: 'The Journey: From Suffolk to the Southern Seas', 
        tab: 'journey-suffolk', 
        description: 'The 1850 voyage of John and Anne/Esther Denton and seven children aboard the Sir George Seymour.' 
      },
      { 
        title: 'The Dentons: Canterbury Pilgrims', 
        tab: 'dentons', 
        description: 'Early settlement in Opawa and Eyreton; burial at Barbadoes Street Cemetery.' 
      },
      { 
        title: 'Chronology (1850, 1857)', 
        tab: 'acknowledgement', 
        description: 'Arrival of First Four Ships in Lyttelton in December 1850; death in 1857.' 
      }
    ]
  },
  {
    id: 'denton-esther',
    firstName: 'Esther',
    lastName: 'Denton',
    maidenName: 'King',
    gender: 'female',
    birthYear: 1811,
    birthPlace: 'Suffolk, England',
    deathYear: 1903,
    deathPlace: 'Eyreton, Canterbury, New Zealand',
    isLiving: false,
    bio: 'Esther Denton (nee King) arrived in New Zealand in 1857 on the "Sir Edward Paget", joining her family in Canterbury. Following the death of her husband John, she farmed at Fishley Farm, Eyreton, living to the age of 92. Buried beside Frederick Denton at Eyreton Cemetery.',
    occupation: 'Pioneer Farmer of Fishley Farm',
    generation: 1,
    branchTag: 'Denton Family',
    spouseIds: ['denton-john-f'],
    childrenIds: [
      'denton-arthur-john', 
      'denton-thomas-charles', 
      'denton-john-frederick-jr'
    ],
    sourceReferences: [
      { 
        title: 'The Dentons: Canterbury Pilgrims', 
        tab: 'dentons', 
        description: 'Settlement at Fishley Farm, Eyreton; buried at Eyreton Cemetery.' 
      },
      { 
        title: 'Chronology (1857, 1903)', 
        tab: 'acknowledgement', 
        description: 'Arrived on Sir Edward Paget in 1857; died in 1903 aged 92.' 
      }
    ]
  },
  {
    id: 'roberts-edward-lonfa',
    firstName: 'Edward',
    lastName: 'Roberts',
    gender: 'male',
    birthYear: 1813,
    birthPlace: 'Penmaenmawr, Caernarfonshire, Wales',
    deathYear: 1898,
    deathPlace: 'Penmaenmawr, Wales',
    isLiving: false,
    photoUrl: '/images/171 Edward Roberts 1813 - 1898.jpg',
    image: '/images/171 Edward Roberts 1813 - 1898.jpg',
    bio: 'Architect, quarry contractor, and builder in Penmaenmawr, North Wales. Builder of Plas Isa and Lonfa. Inherited the title of Pencenedl (Chief of Kindred of the Roberts Family) in 1871. Father of Robert Morris Roberts who emigrated to New Zealand.',
    occupation: 'Architect, Quarry Contractor & Pencenedl',
    generation: 1,
    branchTag: 'Roberts Family',
    spouseIds: [],
    childrenIds: ['roberts-robert-morris-sr'],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 1: Wales to New Zealand', 
        tab: 'roberts', 
        description: 'Architectural works at Penmaenmawr, Lonfa homestead, and hereditary Chief of Kindred lineage.' 
      },
      { 
        title: 'Chronology (1813, 1857, 1871, 1872, 1898)', 
        tab: 'acknowledgement', 
        description: 'Built Plas Isa 1857; Pencenedl 1871; built Lonfa 1872; died 1898.' 
      }
    ]
  },
  {
    id: 'roberts-robert-morris-sr',
    firstName: 'Robert Morris',
    lastName: 'Roberts',
    gender: 'male',
    birthYear: 1838,
    birthPlace: 'Penmaenmawr, Wales',
    deathYear: 1921,
    deathPlace: 'Christchurch, New Zealand',
    isLiving: false,
    photoUrl: '/images/186G Robert Morr5is Roberts aged 23 (1842 - 1921).jpg',
    image: '/images/186G Robert Morr5is Roberts aged 23 (1842 - 1921).jpg',
    bio: 'Son of Edward Roberts of Lonfa. Apprenticed to sea in Liverpool in 1857, arrived in New Zealand in 1862. Married Sarah Elizabeth Baxter in 1866 and operated the Taramakau Accommodation House on the West Coast gold road. Later farmed at Cabbage Tree Flat (Motunau), Happy Valley, and Plas Isa in Waikari before retiring to Champion Street, Christchurch.',
    occupation: 'Accommodation House Keeper, Road Contractor & Sheep Farmer',
    generation: 1,
    branchTag: 'Roberts Family',
    fatherId: 'roberts-edward-lonfa',
    spouseIds: ['baxter-sarah-elizabeth'],
    childrenIds: [
      'roberts-eliza-catherine',
      'roberts-thomas-edward-lloyd',
      'roberts-robert-morris-jr',
      'roberts-edward-ted'
    ],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 1: Wales to New Zealand', 
        tab: 'roberts', 
        description: 'Apprenticeship to sea, voyage to New Zealand, Otago goldfields.' 
      },
      { 
        title: 'The Roberts Family - Part 2: Literate, Hard Working and Resourceful', 
        tab: 'roberts', 
        description: 'Taramakau Accommodation House, Cabbage Tree Flat, Happy Valley, Plas Isa.' 
      },
      { 
        title: 'Chronology (1838, 1862, 1866, 1876, 1890, 1917, 1921)', 
        tab: 'acknowledgement', 
        description: 'Arrived in NZ 1862; married Sarah Baxter 1866; Golden Wedding 1917; died 1921.' 
      }
    ]
  },
  {
    id: 'baxter-sarah-elizabeth',
    firstName: 'Sarah Elizabeth',
    lastName: 'Roberts',
    maidenName: 'Baxter',
    gender: 'female',
    birthYear: 1846,
    birthPlace: 'County Down, Ireland',
    deathYear: 1944,
    deathPlace: 'Christchurch, New Zealand',
    isLiving: false,
    photoUrl: '/images/186C Golden Wedding 1916.jpg',
    image: '/images/186C Golden Wedding 1916.jpg',
    bio: 'Emigrated to New Zealand with her mother Margaret Bunting on the "British Empire" in 1864. Met Robert Morris Roberts on a dray in Kaiapoi, married in 1866 and co-managed the Taramakau Accommodation House on the West Coast coach road. She purchased land at Motunau with her Irish inheritance. Lived to the age of 98.',
    occupation: 'Pioneer Accommodation House Keeper & Landowner',
    generation: 1,
    branchTag: 'Roberts Family',
    spouseIds: ['roberts-robert-morris-sr'],
    childrenIds: [
      'roberts-eliza-catherine',
      'roberts-thomas-edward-lloyd',
      'roberts-robert-morris-jr',
      'roberts-edward-ted'
    ],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 2: Literate, Hard Working and Resourceful', 
        tab: 'roberts', 
        description: 'Voyage on British Empire, Taramakau Accommodation House, Irish gold sovereigns.' 
      },
      { 
        title: 'Chronology (1846, 1864, 1866, 1878, 1917, 1944)', 
        tab: 'acknowledgement', 
        description: 'Arrived on British Empire 1864; married 1866; died 1944 aged 98.' 
      }
    ]
  },
  {
    id: 'gibb-stewart-burnett-sr',
    firstName: 'Stewart Burnett',
    lastName: 'Gibb',
    gender: 'male',
    birthYear: 1833,
    birthPlace: 'Glen Clova, Angus, Scotland',
    deathYear: 1867,
    deathPlace: 'Motunau River, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/157 Stewart Burnett Gibb.jpg',
    image: '/images/157 Stewart Burnett Gibb.jpg',
    bio: 'Emigrated from Glen Clova, Scotland on the "Matoaka" in 1860. Worked as head shepherd at Teviotdale Station. In 1863 he married Helen Lindsay (who arrived on the Accrington) and purchased land at Cabbage Tree Flat. Drowned crossing the flooded Motunau River in 1867.',
    occupation: 'Shepherd & Runholder',
    generation: 1,
    branchTag: 'Gibb Family',
    spouseIds: ['gibb-helen-lindsay'],
    childrenIds: ['gibb-james-lindsay'],
    sourceReferences: [
      { 
        title: 'The Gibb Family: From Glen Clova to Motunau', 
        tab: 'gibbs', 
        description: 'Matoaka voyage 1860, Teviotdale shepherd, settlement at Cabbage Tree Flat.' 
      },
      { 
        title: 'Chronology (1860, 1863, 1866, 1867)', 
        tab: 'acknowledgement', 
        description: 'Arrival on Matoaka 1860; married Helen Lindsay 1863; drowned 1867.' 
      }
    ]
  },
  {
    id: 'gibb-helen-lindsay',
    firstName: 'Helen',
    lastName: 'Gibb',
    maidenName: 'Lindsay',
    gender: 'female',
    birthYear: 1833,
    birthPlace: 'Glen Clova, Angus, Scotland',
    deathYear: 1914,
    deathPlace: 'Motunau, North Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/149 Helen Gibb and her brother Rev George Lindsay with wider family 1907.jpg',
    image: '/images/149 Helen Gibb and her brother Rev George Lindsay with wider family 1907.jpg',
    bio: 'Arrived in Lyttelton in 1863 on the "Accrington". Married Stewart Burnett Gibb. Following his drowning in 1867, she raised four children, ran the Cabbage Tree Flat Accommodation House, and served as Motunau Postmistress from 1883 until retirement in 1900.',
    occupation: 'Motunau Postmistress & Accommodation House Keeper',
    generation: 1,
    branchTag: 'Gibb Family',
    spouseIds: ['gibb-stewart-burnett-sr'],
    childrenIds: ['gibb-james-lindsay'],
    sourceReferences: [
      { 
        title: 'The Gibb Family: From Glen Clova to Motunau', 
        tab: 'gibbs', 
        description: 'Postmistress duties, Cabbage Tree Flat Accommodation House, Berkshire pigs.' 
      },
      { 
        title: 'Chronology (1833, 1863, 1867, 1883, 1900, 1914)', 
        tab: 'acknowledgement', 
        description: 'Arrived on Accrington 1863; Motunau Postmistress 1883-1900; died 1914.' 
      }
    ]
  },
  {
    id: 'lindsay-rev-george',
    firstName: 'George',
    lastName: 'Lindsay',
    gender: 'male',
    birthYear: 1850,
    birthPlace: 'Glen Clova, Angus, Scotland',
    deathYear: 1933,
    deathPlace: 'Southbridge, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/164A Rev George Lindsay.jpg',
    image: '/images/164A Rev George Lindsay.jpg',
    bio: 'Brother of Helen Gibb. Sent out by the Free Church of Scotland in 1873, ordained at Waimate in 1876. Served parishes at Otepopo/Herbert, St Paul\'s Invercargill, and Southbridge. Elected Moderator of the General Assembly of the Presbyterian Church of New Zealand in 1911.',
    occupation: 'Presbyterian Minister & Moderator of the General Assembly',
    generation: 1,
    branchTag: 'Gibb Family',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Gibb Family: Rev George Lindsay', 
        tab: 'gibbs', 
        description: 'Presbyterian ministry, parish pastoral work, election as Moderator in 1911.' 
      },
      { 
        title: 'Chronology (1850, 1873, 1876, 1882, 1889, 1911, 1933)', 
        tab: 'acknowledgement', 
        description: 'Arrived in NZ 1873; ordained 1876; Moderator 1911; died 1933.' 
      }
    ]
  },
  {
    id: 'giles-launcelot',
    firstName: 'Launcelot',
    lastName: 'Giles',
    gender: 'male',
    birthYear: 1818,
    birthPlace: 'Somerset, England',
    deathYear: 1900,
    deathPlace: 'Eyreton, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/165 Launcelot Giles born 1818.jpg',
    image: '/images/165 Launcelot Giles born 1818.jpg',
    bio: 'Arrived in Lyttelton on the "Oriental" in 1857. Pioneer farmer in North Canterbury at Eyreton and Fernside. Father of Eliza Jane Giles who married Jack Denton.',
    occupation: 'Canterbury Pioneer Farmer',
    generation: 1,
    branchTag: 'Giles Family',
    spouseIds: [],
    childrenIds: ['giles-eliza-jane'],
    sourceReferences: [
      { 
        title: 'The Giles Family: From Somerset to Eyreton', 
        tab: 'giles', 
        description: 'Voyage on Oriental 1857, early farming at Eyreton.' 
      },
      { 
        title: 'Chronology (1818, 1857, 1879, 1900)', 
        tab: 'acknowledgement', 
        description: 'Arrival on Oriental 1857; marriage to Phebe Moore; death in 1900.' 
      }
    ]
  },

  // GENERATION 2: Settler Children & Ballot Pioneers (1860s - 1930s)
  {
    id: 'denton-arthur-john',
    firstName: 'Arthur John',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1840,
    birthPlace: 'Little Whelnetham, Suffolk, England',
    deathYear: 1923,
    deathPlace: 'Gisborne, New Zealand',
    isLiving: false,
    photoUrl: '/images/42 Arthur and Julia Denton.jpg',
    image: '/images/42 Arthur and Julia Denton.jpg',
    bio: 'Arrived in Lyttelton on the "Sir George Seymour" in 1850. Married Julia Wilson in 1857. Worked as a contract ploughman and farmer at Rangiora and Eyreton, moved to Oamaru in 1874, and later settled in the Gisborne district.',
    occupation: 'Farmer & Contract Ploughman',
    generation: 2,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-f',
    motherId: 'denton-esther',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Dentons: Arthur John Denton', 
        tab: 'dentons', 
        description: 'Ploughing contractor in Rangiora and Oamaru; later settlement in Gisborne.' 
      },
      { 
        title: 'Chronology (1840, 1850, 1857, 1874, 1923)', 
        tab: 'acknowledgement', 
        description: 'Arrived on First Four Ships; married Julia Wilson; moved to Oamaru and Gisborne.' 
      }
    ]
  },
  {
    id: 'denton-thomas-charles',
    firstName: 'Thomas Charles',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1852,
    birthPlace: 'Canterbury, New Zealand',
    deathYear: 1910,
    deathPlace: 'Cheltenham, Manawatu, New Zealand',
    isLiving: false,
    photoUrl: '/images/45 Thomas Charles Denton on horseback.jpg',
    image: '/images/45 Thomas Charles Denton on horseback.jpg',
    bio: 'Son of John and Esther Denton. Married Helen White in 1877. In 1882 he drew a ballot farm in the Manawatu, clearing bush and establishing a sheep farm near Cheltenham. Skilled horseman and agriculturalist.',
    occupation: 'Sheep Farmer & Manawatu Pioneer',
    generation: 2,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-f',
    motherId: 'denton-esther',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Dentons: Thomas Charles Denton', 
        tab: 'dentons', 
        description: 'Manawatu ballot farm, Cheltenham farming, horse breeding.' 
      },
      { 
        title: 'Chronology (1852, 1877, 1882, 1910)', 
        tab: 'acknowledgement', 
        description: 'Married Helen White 1877; Manawatu ballot farm 1882; died 1910.' 
      }
    ]
  },
  {
    id: 'denton-john-frederick-jr',
    firstName: 'John Frederick',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1862,
    birthPlace: 'Eyreton, Canterbury, New Zealand',
    deathYear: 1903,
    deathPlace: 'Domett, Cheviot, New Zealand',
    isLiving: false,
    photoUrl: '/images/67 Jack Denton with Margaret, Lance and Harry.jpg',
    image: '/images/67 Jack Denton with Margaret, Lance and Harry.jpg',
    bio: 'Known as Jack. Leased land in Greta Valley and later farmed at Domett, Cheviot. Married Eliza Jane Giles in 1882. Together they raised seven children including John Thomas (Tommy) Denton before Jack\'s early passing in 1903.',
    occupation: 'Farmer & Agricultural Contractor',
    generation: 2,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-f',
    motherId: 'denton-esther',
    spouseIds: ['giles-eliza-jane'],
    childrenIds: ['denton-john-thomas'],
    sourceReferences: [
      { 
        title: 'The Dentons: Jack and Eliza Denton', 
        tab: 'dentons', 
        description: 'Greta Valley lease, Domett ballot farm in Cheviot.' 
      },
      { 
        title: 'Chronology (1862, 1882, 1894, 1903)', 
        tab: 'acknowledgement', 
        description: 'Married Eliza Giles 1882; Cheviot ballot 1894; died 1903.' 
      }
    ]
  },
  {
    id: 'giles-eliza-jane',
    firstName: 'Eliza Jane',
    lastName: 'Giles',
    maidenName: 'Giles',
    gender: 'female',
    birthYear: 1865,
    birthPlace: 'Eyreton, Canterbury, New Zealand',
    deathYear: 1938,
    deathPlace: 'Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/72 Eliza Denton, Tommy_s mother, with Ivy 1894.jpg',
    image: '/images/72 Eliza Denton, Tommy_s mother, with Ivy 1894.jpg',
    bio: 'Daughter of Launcelot Giles and Margaret Marshall. In 1894 she drew and successfully won a Cheviot ballot farm at Domett in her own right as a married woman. After Jack Denton died in 1903, she raised her young family on the land, later marrying James Murchison in 1906.',
    occupation: 'Ballot Farm Pioneer & Homemaker',
    generation: 2,
    branchTag: 'Giles Family',
    fatherId: 'giles-launcelot',
    spouseIds: ['denton-john-frederick-jr'],
    childrenIds: ['denton-john-thomas'],
    sourceReferences: [
      { 
        title: 'The Giles Family: From Somerset to Eyreton', 
        tab: 'giles', 
        description: 'Cheviot ballot farm win, Domett homestead.' 
      },
      { 
        title: 'The Dentons: Jack and Eliza Denton', 
        tab: 'dentons', 
        description: 'Pioneering farming at Domett.' 
      },
      { 
        title: 'Chronology (1865, 1882, 1894, 1906, 1938)', 
        tab: 'acknowledgement', 
        description: 'Born at Eyreton 1865; Cheviot ballot win 1894; married James Murchison 1906.' 
      }
    ]
  },
  {
    id: 'roberts-thomas-edward-lloyd',
    firstName: 'Thomas Edward Lloyd',
    lastName: 'Roberts',
    gender: 'male',
    birthYear: 1873,
    birthPlace: 'Taramakau, West Coast, New Zealand',
    deathYear: 1959,
    deathPlace: 'Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/189 Thomas Edward Lloyd Roberts, known as Tom.jpg',
    image: '/images/189 Thomas Edward Lloyd Roberts, known as Tom.jpg',
    bio: 'Known as T.E.L. or Tom Roberts. In 1900 he drew a ballot farm on the Starborough Estate in Marlborough. In 1908 he married Chrystabel Murray and took over Plas Isa in Waikari. In 1924 he became Pencenedl (Chief of Kindred of the Roberts Family). Author of "Beyond the Hills of Hundalee" and "Motunau or The Hills of Home".',
    occupation: 'Pencenedl (Chief of Kindred), Author & Farmer',
    generation: 2,
    branchTag: 'Roberts Family',
    fatherId: 'roberts-robert-morris-sr',
    motherId: 'baxter-sarah-elizabeth',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 4: Starborough Ballot and T.E.L. Roberts', 
        tab: 'roberts', 
        description: 'Starborough ballot farm, Pencenedl title, author of Hundalee.' 
      },
      { 
        title: 'Chronology (1873, 1900, 1908, 1924, 1959)', 
        tab: 'acknowledgement', 
        description: 'Starborough ballot 1900; married Chrystabel Murray 1908; Pencenedl 1924; died 1959.' 
      }
    ]
  },
  {
    id: 'roberts-robert-morris-jr',
    firstName: 'Robert Morris',
    lastName: 'Roberts',
    gender: 'male',
    birthYear: 1874,
    birthPlace: 'Cabbage Tree Flat, Motunau, New Zealand',
    deathYear: 1947,
    deathPlace: 'Troqueer, Ward, Marlborough, New Zealand',
    isLiving: false,
    photoUrl: '/images/190 Robert Morris Roberts jn, known as Morris or Murray.jpg',
    image: '/images/190 Robert Morris Roberts jn, known as Morris or Murray.jpg',
    bio: 'Known as Morris. In 1902 he took up a 999-year leasehold farm at Blind River. In 1903 he married Phoebe Armstrong of Loburn. In 1910 he purchased Run 176 ("Troqueer") on Needles Road near Ward, Marlborough, where the Roberts family has farmed for over a century.',
    occupation: 'Sheep Farmer of Troqueer',
    generation: 2,
    branchTag: 'Roberts Family',
    fatherId: 'roberts-robert-morris-sr',
    motherId: 'baxter-sarah-elizabeth',
    spouseIds: ['armstrong-phoebe'],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 5: Robert Morris Roberts on Troqueer', 
        tab: 'roberts', 
        description: 'Blind River farm, marriage to Phoebe Armstrong, purchase of Troqueer 1910.' 
      },
      { 
        title: 'Chronology (1874, 1902, 1903, 1910, 1947)', 
        tab: 'acknowledgement', 
        description: 'Blind River lease 1902; married Phoebe Armstrong 1903; Troqueer purchase 1910.' 
      }
    ]
  },
  {
    id: 'armstrong-phoebe',
    firstName: 'Phoebe',
    lastName: 'Roberts',
    maidenName: 'Armstrong',
    gender: 'female',
    birthPlace: 'Loburn, Canterbury, New Zealand',
    deathYear: 1933,
    deathPlace: 'Troqueer, Ward, Marlborough, New Zealand',
    isLiving: false,
    photoUrl: '/images/225 Phoebe and Robert Morris Roberts with Greta, Constance, Frank, Marhjorie and Gordon.jpg',
    image: '/images/225 Phoebe and Robert Morris Roberts with Greta, Constance, Frank, Marhjorie and Gordon.jpg',
    bio: 'From Loburn, Canterbury. Kept house at Star Hill for her brother George Armstrong before marrying Robert Morris Roberts Jnr in 1903. Pioneer homemaker at Blind River and Troqueer, raising five children on the remote station.',
    occupation: 'Pioneer Homemaker & Station Manager',
    generation: 2,
    branchTag: 'Roberts Family',
    spouseIds: ['roberts-robert-morris-jr'],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 5: Robert Morris Roberts on Troqueer', 
        tab: 'roberts', 
        description: 'Courtship, letter extracts, life on Troqueer station.' 
      },
      { 
        title: 'Chronology (1903, 1933)', 
        tab: 'acknowledgement', 
        description: 'Married Morris Roberts 1903; died 1933.' 
      }
    ]
  },
  {
    id: 'roberts-edward-ted',
    firstName: 'Edward',
    lastName: 'Roberts',
    gender: 'male',
    birthYear: 1882,
    birthPlace: 'Cabbage Tree Flat, Motunau, New Zealand',
    deathYear: 1968,
    deathPlace: 'Culverden, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/193 Edward Roberts, known as Ted.jpg',
    image: '/images/193 Edward Roberts, known as Ted.jpg',
    bio: 'Known as Ted. In 1908 he drew a ballot farm at Culverden named "Riverside". Married Jenny Trueman in 1907. Married Eva Fanny Rinaldi in 1929. Author of "A Personal History", actively involved in North Canterbury community, agricultural trials, and church.',
    occupation: 'Ballot Farmer & Author of "A Personal History"',
    generation: 2,
    branchTag: 'Roberts Family',
    fatherId: 'roberts-robert-morris-sr',
    motherId: 'baxter-sarah-elizabeth',
    spouseIds: [],
    childrenIds: ['roberts-edward-t'],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 3: Ted Roberts and Riverside', 
        tab: 'roberts', 
        description: 'Culverden ballot farm Riverside, author of A Personal History.' 
      },
      { 
        title: 'Chronology (1882, 1907, 1908, 1913, 1929, 1968)', 
        tab: 'acknowledgement', 
        description: 'Married Jenny Trueman 1907; Riverside ballot 1908; married Eva Rinaldi 1929; died 1968.' 
      }
    ]
  },
  {
    id: 'gibb-james-lindsay',
    firstName: 'James Lindsay',
    lastName: 'Gibb',
    gender: 'male',
    birthYear: 1858,
    birthPlace: 'Glen Clova, Angus, Scotland',
    deathYear: 1932,
    deathPlace: 'Motunau, North Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/154 James Gibb.jpg',
    image: '/images/154 James Gibb.jpg',
    bio: 'Arrived in New Zealand as a young boy on the "Accrington" in 1863 with mother Helen. On Christmas Eve 1891, he married Eliza Catherine Roberts. Farmed at Motunau using heavy draught horse teams and raised four children: Helen Isabel, Annie (later Denton), Robert Morris Stewart, and Lina.',
    occupation: 'Sheep Farmer & Heavy Draught Horse Contractor',
    generation: 2,
    branchTag: 'Gibb Family',
    fatherId: 'gibb-stewart-burnett-sr',
    motherId: 'gibb-helen-lindsay',
    spouseIds: ['roberts-eliza-catherine'],
    childrenIds: ['gibb-annie'],
    sourceReferences: [
      { 
        title: 'The Gibb Family: From Glen Clova to Motunau', 
        tab: 'gibbs', 
        description: 'Horse teams, farming at Motunau, marriage to Eliza Roberts.' 
      },
      { 
        title: 'Chronology (1858, 1863, 1891, 1932)', 
        tab: 'acknowledgement', 
        description: 'Born in Scotland; arrived 1863; married Christmas Eve 1891; died 1932.' 
      }
    ]
  },
  {
    id: 'roberts-eliza-catherine',
    firstName: 'Eliza Catherine',
    lastName: 'Gibb',
    maidenName: 'Roberts',
    gender: 'female',
    birthYear: 1870,
    birthPlace: 'Taramakau Accommodation House, West Coast, New Zealand',
    deathYear: 1914,
    deathPlace: 'Motunau, North Canterbury, New Zealand',
    isLiving: false,
    bio: 'Eldest child of Robert Morris Roberts and Sarah Elizabeth Baxter. Born at the Taramakau Accommodation House on the West Coast road. Married James Lindsay Gibb on Christmas Eve 1891. Mother of Annie Gibb (later Denton).',
    occupation: 'Pioneer Homemaker',
    generation: 2,
    branchTag: 'Roberts Family',
    fatherId: 'roberts-robert-morris-sr',
    motherId: 'baxter-sarah-elizabeth',
    spouseIds: ['gibb-james-lindsay'],
    childrenIds: ['gibb-annie'],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 2: Literate, Hard Working and Resourceful', 
        tab: 'roberts', 
        description: 'Born at Taramakau, childhood at Cabbage Tree Flat.' 
      },
      { 
        title: 'The Gibb Family: From Glen Clova to Motunau', 
        tab: 'gibbs', 
        description: 'Marriage to James Lindsay Gibb on Christmas Eve 1891.' 
      },
      { 
        title: 'Chronology (1870, 1891, 1914)', 
        tab: 'acknowledgement', 
        description: 'Born 1870; married James Gibb 1891; died 1914.' 
      }
    ]
  },

  // GENERATION 3: 20th Century Pioneers & Veterans (1880s - 1960s)
  {
    id: 'denton-john-thomas',
    firstName: 'John Thomas',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1887,
    birthPlace: 'Greta Valley, North Canterbury, New Zealand',
    deathYear: 1968,
    deathPlace: 'Southbridge, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/109 Tom and Annie Denton, 1968.jpg',
    image: '/images/109 Tom and Annie Denton, 1968.jpg',
    bio: 'Known as Tommy. Drew a ballot farm at Motunau in 1910. Enlisted in the Canterbury Mounted Rifles in WWI and served at Gallipoli, being wounded and invalided home in 1917. In 1919 he married Annie Gibb. In 1927 they sold Motunau and purchased "Oakdale" near Southbridge.',
    occupation: 'Farmer & WWI Gallipoli Veteran (Canterbury Mounted Rifles)',
    generation: 3,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-frederick-jr',
    motherId: 'giles-eliza-jane',
    spouseIds: ['gibb-annie'],
    childrenIds: [
      'denton-frederick-harry',
      'denton-florence-isabel',
      'denton-thomas-warren',
      'denton-heather-helen'
    ],
    sourceReferences: [
      { 
        title: 'The Dentons: Tommy and Annie Denton of Motunau', 
        tab: 'dentons', 
        description: 'Motunau farming, Gallipoli campaign service, Oakdale at Southbridge.' 
      },
      { 
        title: 'Chronology (1887, 1910, 1914, 1917, 1919, 1927, 1968)', 
        tab: 'acknowledgement', 
        description: 'Motunau ballot 1910; Gallipoli 1915; married Annie Gibb 1919; Oakdale 1927; died 1968.' 
      }
    ]
  },
  {
    id: 'gibb-annie',
    firstName: 'Annie',
    lastName: 'Denton',
    maidenName: 'Gibb',
    gender: 'female',
    birthYear: 1894,
    birthPlace: 'Motunau, North Canterbury, New Zealand',
    deathYear: 1991,
    deathPlace: 'Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/87 Annie Denton in her 80_s.jpg',
    image: '/images/87 Annie Denton in her 80_s.jpg',
    bio: 'Daughter of James Lindsay Gibb and Eliza Catherine Roberts. Grew up at Motunau and attended Greta Valley School. Married Tommy Denton in 1919 and partnered in farming at Motunau and Oakdale, Southbridge. Celebrated her 97th birthday in 1991.',
    occupation: 'Homemaker & Farmer',
    generation: 3,
    branchTag: 'Gibb Family',
    fatherId: 'gibb-james-lindsay',
    motherId: 'roberts-eliza-catherine',
    spouseIds: ['denton-john-thomas'],
    childrenIds: [
      'denton-frederick-harry',
      'denton-florence-isabel',
      'denton-thomas-warren',
      'denton-heather-helen'
    ],
    sourceReferences: [
      { 
        title: 'The Dentons: Tommy and Annie Denton of Motunau', 
        tab: 'dentons', 
        description: 'Childhood at Motunau, life at Oakdale.' 
      },
      { 
        title: 'The Gibb Family: From Glen Clova to Motunau', 
        tab: 'gibbs', 
        description: 'Daughter of James Lindsay Gibb and Eliza Catherine Roberts.' 
      },
      { 
        title: 'Chronology (1894, 1919, 1927, 1991)', 
        tab: 'acknowledgement', 
        description: 'Born at Motunau 1894; married Tommy Denton 1919; move to Oakdale 1927; died 1991.' 
      }
    ]
  },
  {
    id: 'roberts-edward-t',
    firstName: 'Edward T.',
    lastName: 'Roberts',
    gender: 'male',
    birthYear: 1913,
    birthPlace: 'Riverside, Culverden, New Zealand',
    deathYear: 1999,
    deathPlace: 'Canterbury, New Zealand',
    isLiving: false,
    bio: 'Robert Charles Edward Trueman Roberts, known as Edward T. Son of Ted Roberts and Jenny Trueman. Raised at Riverside by his father and aunt Margaret. Married Amy Wooding in 1938. Author of "A Brief Record of Our Family", family genealogist whose historical records underpin the Roberts lineage.',
    occupation: 'Farmer & Family Historian (Author of "A Brief Record of Our Family")',
    generation: 3,
    branchTag: 'Roberts Family',
    fatherId: 'roberts-edward-ted',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Roberts Family - Part 3: Ted Roberts and Riverside', 
        tab: 'roberts', 
        description: 'Author of A Brief Record of Our Family.' 
      },
      { 
        title: 'Acknowledgments and Thanks', 
        tab: 'acknowledgement', 
        description: 'Research and documented family records from Edward T. Roberts and Richard Lovell Roberts.' 
      },
      { 
        title: 'Chronology (1913, 1938, 1999)', 
        tab: 'acknowledgement', 
        description: 'Born 1913; married Amy Wooding 1938; died 1999.' 
      }
    ]
  },

  // GENERATION 4: WWII Generation & Living Descendants (1920s - Present)
  {
    id: 'denton-frederick-harry',
    firstName: 'Frederick Harry',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1920,
    birthPlace: 'Southbridge, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/114 Harry Denton at Presentation Ceremony.jpg',
    image: '/images/114 Harry Denton at Presentation Ceremony.jpg',
    bio: 'Eldest son of Tommy and Annie Denton. During World War II he trained as a pilot and served with RAF Bomber Command, captaining Lancaster bombers with 75 (NZ) Squadron. Flew 30 operational sorties over occupied Europe and Germany and was awarded the Distinguished Flying Cross (DFC).',
    occupation: 'Lancaster Pilot, DFC, RAF Bomber Command & Farmer',
    generation: 4,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-thomas',
    motherId: 'gibb-annie',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Dentons: Frederick Harry Denton DFC', 
        tab: 'dentons', 
        description: 'Pilot Officer, 75 (NZ) Squadron, Lancaster bombers, DFC presentation.' 
      },
      { 
        title: 'Chronology (1920, 1944)', 
        tab: 'acknowledgement', 
        description: 'Born in Southbridge 1920; DFC presentation ceremony.' 
      }
    ]
  },
  {
    id: 'denton-florence-isabel',
    firstName: 'Florence Isabel',
    lastName: 'Denton',
    gender: 'female',
    birthYear: 1921,
    birthPlace: 'Southbridge, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/125 Isabel Denton.png',
    image: '/images/125 Isabel Denton.png',
    bio: 'Eldest daughter of Tommy and Annie Denton. During World War II she enlisted in the New Zealand Women\'s Land Service (Land Girls), working farming stations at Maungati, driving horse teams and tractors in wartime agricultural production.',
    occupation: 'NZ Women\'s Land Service & Farmer',
    generation: 4,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-thomas',
    motherId: 'gibb-annie',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Dentons: Isabel Denton & Women\'s Land Service', 
        tab: 'dentons', 
        description: 'Service at Maungati station, horse teams, wartime agricultural production.' 
      },
      { 
        title: 'Chronology (1921, 1942)', 
        tab: 'acknowledgement', 
        description: 'Born in Southbridge 1921; NZ Women\'s Land Service.' 
      }
    ]
  },
  {
    id: 'denton-thomas-warren',
    firstName: 'Thomas Warren',
    lastName: 'Denton',
    gender: 'male',
    birthYear: 1923,
    birthPlace: 'Southbridge, Canterbury, New Zealand',
    isLiving: false,
    photoUrl: '/images/134 Warren Denton with ZK GAE in 1959.jpg',
    image: '/images/134 Warren Denton with ZK GAE in 1959.jpg',
    bio: 'Second son of Tommy and Annie Denton. Aviator and agricultural topdressing pilot, operating Tiger Moths and Piper aircraft (ZK GAE) throughout Canterbury.',
    occupation: 'Aerial Topdressing Pilot & Farmer',
    generation: 4,
    branchTag: 'Denton Family',
    fatherId: 'denton-john-thomas',
    motherId: 'gibb-annie',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'The Dentons: Oakdale Aviation', 
        tab: 'dentons', 
        description: 'Tiger Moth topdressing, pilot records.' 
      },
      { 
        title: 'Chronology (1923, 1959)', 
        tab: 'acknowledgement', 
        description: 'Born in Southbridge 1923; topdressing flights in Piper ZK GAE.' 
      }
    ]
  },
  {
    id: 'denton-heather-helen',
    firstName: 'Heather Helen',
    lastName: 'Denton',
    gender: 'female',
    birthYear: 1932,
    birthPlace: 'Southbridge, Canterbury, New Zealand',
    isLiving: true,
    bio: 'Youngest daughter of Tommy and Annie Denton, born at Oakdale near Southbridge. Mother of author Christine Negus. Provided direct personal memories, photographs, and oral history documentation for this historical archive.',
    generation: 4,
    branchTag: 'Negus Family',
    fatherId: 'denton-john-thomas',
    motherId: 'gibb-annie',
    spouseIds: [],
    childrenIds: [],
    sourceReferences: [
      { 
        title: 'Acknowledgments and Thanks', 
        tab: 'acknowledgement', 
        description: 'Direct memories and historical family records provided by Heather Tangye (nee Denton, previously Negus).' 
      },
      { 
        title: 'Chronology (1932)', 
        tab: 'acknowledgement', 
        description: 'Born in Southbridge 1932.' 
      }
    ]
  }
];

export const INITIAL_STORIES: Story[] = [
  {
    id: 's1',
    title: 'The 1850 Voyage to Canterbury: Sir George Seymour',
    year: 1850,
    decade: '1850s',
    authorName: 'Denton Family Archives',
    category: 'oral_history',
    summary: 'The 1850 voyage of John and Anne/Esther Denton and seven children from Suffolk to Lyttelton aboard the First Four Ship Sir George Seymour.',
    content: `In September 1850, the full-rigged sailing ship Sir George Seymour departed Plymouth Sound bound for Canterbury, New Zealand. Among the passengers were John Frederick Denton, his wife, and their children.

For over three months, the small vessel negotiated Atlantic swells, crossed the doldrums, and plunged through the Roaring Forties before sighting the jagged headlands of Banks Peninsula in December 1850.

Upon anchoring at Lyttelton Harbour, the Denton family faced the daunting challenge of crossing the Bridle Path over the Port Hills with their possessions to build sod cottages on the Canterbury Plains. Their courage established the Denton roots that flourished across Eyreton, Greta Valley, and Southbridge for generations.`,
    coverImageUrl: '/images/8 Sir George Seymour.jpg',
    taggedMemberIds: ['denton-john-f', 'denton-esther', 'denton-arthur-john'],
    tags: ['Denton', 'Canterbury Pilgrims', 'Sir George Seymour', 'Lyttelton', 'Suffolk'],
    dateAdded: '2024-03-15',
    likesCount: 24,
    comments: []
  },
  {
    id: 's2',
    title: 'Gallipoli & the Canterbury Mounted Rifles: Tommy Denton (1915)',
    year: 1915,
    decade: '1910s',
    authorName: 'Tommy Denton',
    category: 'military',
    summary: 'Letters and battlefield memories of John Thomas (Tommy) Denton during the Gallipoli campaign with the Canterbury Mounted Rifles.',
    content: `In 1914, Tommy Denton volunteered with the Canterbury Mounted Rifles. After desert training at Zeitoun Camp near Cairo, the regiment deployed dismounted to the steep, arid ravines of Anzac Cove, Gallipoli.

Tommy endured months in the front-line trenches under relentless shrapnel and sniper fire before suffering battle wounds that necessitated his evacuation by hospital ship. Invalided home to New Zealand in 1917, Tommy met Annie Gibb of Motunau, and together they farmed and raised a family at Oakdale in Southbridge.`,
    coverImageUrl: '/images/105 Gallipoli camp.jpg',
    taggedMemberIds: ['denton-john-thomas', 'gibb-annie'],
    tags: ['Denton', 'Gallipoli', 'WWI', 'Mounted Rifles', 'Canterbury'],
    dateAdded: '2024-02-10',
    likesCount: 31,
    comments: []
  },
  {
    id: 's3',
    title: 'Bomber Command & 75 (NZ) Squadron: Harry Denton, DFC (1944)',
    year: 1944,
    decade: '1940s',
    authorName: 'Pilot Officer F. H. Denton DFC',
    category: 'military',
    summary: 'Operational tour of Lancaster bomber night sorties over occupied Europe, culminating in the award of the Distinguished Flying Cross.',
    content: `During the height of the air offensive over occupied Europe in World War II, Pilot Officer Frederick Harry Denton served as captain of Lancaster heavy bombers with No. 75 (New Zealand) Squadron.

Harry completed a full operational tour of 30 hazardous night bombing sorties over heavily defended targets in Germany and northern France. His exceptional courage, navigation skill, and leadership brought his crew through repeatedly and earned him the Distinguished Flying Cross (DFC) presented at Buckingham Palace.`,
    coverImageUrl: '/images/114 Harry Denton at Presentation Ceremony.jpg',
    taggedMemberIds: ['denton-frederick-harry'],
    tags: ['Denton', 'RAF Bomber Command', 'DFC', 'Lancaster', 'WWII'],
    dateAdded: '2024-04-02',
    likesCount: 28,
    comments: []
  },
  {
    id: 's4',
    title: 'The West Coast Road & Taramakau: Robert & Sarah Roberts (1866)',
    year: 1866,
    decade: '1860s',
    authorName: 'Sarah Elizabeth Roberts',
    category: 'oral_history',
    summary: 'Managing the Taramakau Accommodation House on the Otira coach road during the 1860s gold rushes.',
    content: `In 1866, newlyweds Robert Morris Roberts and Sarah Elizabeth Baxter took charge of the remote Taramakau Accommodation House situated along the treacherous West Coast goldfield track.

Coaches negotiated the notorious Otira Zig Zag and swollen alpine rivers to reach their roadside sanctuary. Sarah prepared hot meals and dry blankets for gold miners, drovers, and dignitaries including Premier Sir George Grey, storing the sovereign payments in her canvas money belt. Their perseverance became legendary in Canterbury colonial history.`,
    coverImageUrl: '/images/186 1868 Otira_s infamous Zig Zag.jpg',
    taggedMemberIds: ['roberts-robert-morris-sr', 'baxter-sarah-elizabeth'],
    tags: ['Roberts', 'West Coast', 'Taramakau', 'Otira', 'Pioneers'],
    dateAdded: '2024-01-20',
    likesCount: 29,
    comments: []
  },
  {
    id: 's5',
    title: 'Troqueer on the Needles: Morris Roberts & Phoebe Armstrong (1910)',
    year: 1910,
    decade: '1910s',
    authorName: 'Roberts Family Papers',
    category: 'biography',
    summary: 'The acquisition and settlement of Run 176 (Troqueer) on Needles Road near Ward by Morris and Phoebe Roberts.',
    content: `In 1910, Robert Morris Roberts Jnr bought Run 176 in the Ward district of Marlborough, naming the station Troqueer. Moving his wife Phoebe and young children from Blind River, they set about breaking in steep hill country.

They lived initially in a corrugated iron hut before building a substantial homestead, shearing thousands of sheep and surviving severe droughts. Troqueer has remained in the Roberts family for over one hundred years.`,
    coverImageUrl: '/images/223 First dwelling on Troqueer 1910.jpg',
    taggedMemberIds: ['roberts-robert-morris-jr', 'armstrong-phoebe'],
    tags: ['Roberts', 'Troqueer', 'Marlborough', 'Sheep Station'],
    dateAdded: '2024-03-01',
    likesCount: 18,
    comments: []
  },
  {
    id: 's6',
    title: 'Motunau Postmistress: Helen Gibb of Cabbage Tree Flat',
    year: 1883,
    decade: '1880s',
    authorName: 'Gibb Family Archive',
    category: 'biography',
    summary: 'Helen Gibb\'s seventeen years of public service managing the Motunau Post Office and Cabbage Tree Flat Accommodation House.',
    content: `Following the tragic drowning of her husband Stewart Burnett Gibb in 1867, Helen Gibb managed the Cabbage Tree Flat Accommodation House and raised her four children alone.

In 1883, she was officially appointed Motunau Postmistress, operating the postal and telegraph relay from her parlor. Mail coaches from Amberley stopped at her gate, where she sorted correspondence and cared for passing travelers until her retirement in 1900.`,
    coverImageUrl: '/images/148 Helen with James, George, Stewart and Ella at Cabbage tree Flat.jpg',
    taggedMemberIds: ['gibb-helen-lindsay', 'gibb-james-lindsay'],
    tags: ['Gibb', 'Motunau', 'Post Office', 'Cabbage Tree Flat'],
    dateAdded: '2024-02-15',
    likesCount: 21,
    comments: []
  }
];

export const INITIAL_ARCHIVE: ArchiveItem[] = [
  {
    id: 'a1',
    title: 'Arthur and Julia Denton at Rangiora (c. 1870)',
    type: 'photo',
    fileUrl: '/images/42 Arthur and Julia Denton.jpg',
    year: 1870,
    decade: '1870s',
    location: 'Rangiora, Canterbury',
    description: 'Portrait of Canterbury Pilgrim Arthur John Denton and his wife Julia Wilson.',
    taggedMemberIds: ['denton-arthur-john'],
    tags: ['Denton', 'Portrait', 'Rangiora', 'Pilgrim'],
    dateAdded: '2024-01-20',
    addedBy: 'Denton Family Archives'
  },
  {
    id: 'a2',
    title: 'Robert Morris Roberts aged 23 (1865)',
    type: 'photo',
    fileUrl: '/images/186G Robert Morr5is Roberts aged 23 (1842 - 1921).jpg',
    year: 1865,
    decade: '1860s',
    location: 'Canterbury',
    description: 'Early colonial portrait of Robert Morris Roberts shortly after arriving in New Zealand.',
    taggedMemberIds: ['roberts-robert-morris-sr'],
    tags: ['Roberts', 'Portrait', 'West Coast', 'Pioneer'],
    dateAdded: '2024-02-01',
    addedBy: 'Richard Lovell Roberts'
  },
  {
    id: 'a3',
    title: 'Helen Gibb with James, George, Stewart and Ella (c. 1885)',
    type: 'photo',
    fileUrl: '/images/148 Helen with James, George, Stewart and Ella at Cabbage tree Flat.jpg',
    year: 1885,
    decade: '1880s',
    location: 'Cabbage Tree Flat, Motunau',
    description: 'Helen Gibb seated with her four children outside the Motunau homestead.',
    taggedMemberIds: ['gibb-helen-lindsay', 'gibb-james-lindsay'],
    tags: ['Gibb', 'Motunau', 'Family Group', '1880s'],
    dateAdded: '2024-02-28',
    addedBy: 'Gibb Family Papers'
  },
  {
    id: 'a4',
    title: 'Phoebe and Morris Roberts with Family at Troqueer (c. 1918)',
    type: 'photo',
    fileUrl: '/images/225 Phoebe and Robert Morris Roberts with Greta, Constance, Frank, Marhjorie and Gordon.jpg',
    year: 1918,
    decade: '1910s',
    location: 'Troqueer, Ward, Marlborough',
    description: 'Family portrait on the veranda of Troqueer Station with five children.',
    taggedMemberIds: ['roberts-robert-morris-jr', 'armstrong-phoebe'],
    tags: ['Roberts', 'Troqueer', 'Station Life', 'Marlborough'],
    dateAdded: '2024-03-10',
    addedBy: 'Troqueer Archives'
  },
  {
    id: 'a5',
    title: 'Tom and Annie Denton on their Golden Anniversary (1968)',
    type: 'photo',
    fileUrl: '/images/109 Tom and Annie Denton, 1968.jpg',
    year: 1968,
    decade: '1960s',
    location: 'Southbridge, Canterbury',
    description: 'Tommy and Annie Denton in their garden at Oakdale, Southbridge.',
    taggedMemberIds: ['denton-john-thomas', 'gibb-annie'],
    tags: ['Denton', 'Gibb', 'Oakdale', 'Southbridge'],
    dateAdded: '2024-03-25',
    addedBy: 'Heather Tangye (nee Denton)'
  }
];
